import { useSortBy, useTable } from "react-table";
import { useRowSpan } from "../../../common/utils/useRowSpan";
import { Table } from "@/Components/ui";;

const splitKeyProp = (props: any) => {
  const { key, ...rest } = props;
  return { key, props: rest };
};

const getColumnClassName = (column: any) => column.className || column.cellClassName || "";

function SummaryTable({ id, columns, data }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, rowSpanHeaders } = useTable({ columns, data }, (hooks) => hooks.useInstance.push(useRowSpan), useSortBy);

  return (
    <div className="table-responsive">
      <Table id={id} {...getTableProps()} className="custom-header-css table table-nowrap align-middle mb-0">
        <thead className="table-light text-muted">
          {headerGroups.map((headerGroup, idx) => {
            const headerGroupProps = splitKeyProp(headerGroup.getHeaderGroupProps());
            return (
              <tr key={headerGroupProps.key || `${headerGroup.id}-${idx}`} {...headerGroupProps.props}>
                {headerGroup.headers.map((column: any, columnIndex) => {
                  const headerProps = splitKeyProp(column.getHeaderProps());
                  return (
                    <th
                      key={headerProps.key || column.id || columnIndex}
                      {...headerProps.props}
                      className={`px-3 py-2 ${getColumnClassName(column)}`}
                      style={column.size ? { width: column.size } : undefined}
                    >
                      {column.render("Header")}
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);

            for (let j = 0; j < row.allCells.length; j++) {
              let cell = row.allCells[j];
              let rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);

              if (rowSpanHeader) {
                if (rowSpanHeader.topCellValue === null || rowSpanHeader.topCellValue !== cell.value) {
                  cell.isRowSpanned = false;
                  rowSpanHeader.topCellValue = cell.value;
                  rowSpanHeader.topCellIndex = i;
                  cell.rowSpan = 1;
                } else {
                  rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                  cell.isRowSpanned = true;
                }
              }
            }
            return null;
          })}
          {rows.map((row, idx) => {
            const rowProps = splitKeyProp(row.getRowProps());
            return (
              <tr key={rowProps.key || row.original?.id || idx} {...rowProps.props}>
                {row.cells.map((cell: any, cellIndex) => {
                  if (cell.isRowSpanned) return null;

                  const cellProps = splitKeyProp(cell.getCellProps());
                  return (
                    <td
                      key={cellProps.key || cell.column.id || cellIndex}
                      rowSpan={cell.rowSpan}
                      {...cellProps.props}
                      className={`px-3 py-2 ${getColumnClassName(cell.column)}`}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default SummaryTable;
